import { RootState } from 'store';

export const selectors = {
  selectActiveCampaigns: (state: RootState) => state.direction.direction,
};
